export default {"src":"/_next/static/media/paper-plane.97c521a2.svg","height":512,"width":512};